import React, {useEffect} from "react";
import {Menu} from "antd";
import {useState} from "react";
import "../styles/newMinistry.css";
import About1 from "./orgs/About1";
import Mofa1 from "./orgs/Mofa1";
import Orgs from "./orgs/Orgs";
import Police from "./orgs/Police";
import justiceLogo from "../../assets/ministry.jpg";

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}
const items = [
  getItem(
    "Хууль зүй, дотоод хэргийн яам",
    "sub1",
    <img
      id="justice-icon"
      style={{height: "1.2rem", width: "1.2rem"}}
      src={justiceLogo}
      alt="logo"
    />,
    [getItem("Бидний тухай", "1"), getItem("Харъяа байгууллагууд", "2")]
  ),
  getItem("Хөдөө аж ахуй, хөнгөн үйлдвэрлэлийн яам", "sub2", null, [
    getItem("Бидний тухай", "3"),
    getItem("Харъяа байгууллагууд", "4", null),
  ]),
];
const rootSubmenuKeys = ["sub1", "sub2"];
function NewMinistry() {
  const [openKeys, setOpenKeys] = useState(["sub1"]);
  const [key, setKey] = useState("1");
  const onClickHandler = (e) => {
    const keys = e.key;
    setKey(keys);
  };
  useEffect(() => {
    renderContent();
  }, [key]);

  const renderContent = () => {
    switch (key) {
      case "1":
        return <About1 setKey={setKey} />;
      case "3":
        return <Mofa1 />;
      case "2":
        return <Orgs setKey={setKey} />;
      case "7":
        return <About1 setKey={setKey} />;
      case "11":
        return <Police setKey={setKey} />;
      default:
    }
  };
  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };
  return (
    <div className="newministry-container">
      <Menu
        inlineIndent="20"
        style={{
          width: "35%",
          display: "flex",
          flexDirection: "column",
          flex: 1,
          wordBreak: "break-word",
          borderRadius: "1rem",
        }}
        onClick={(e) => onClickHandler(e)}
        defaultSelectedKeys={["1"]}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        defaultOpenKeys={["sub1"]}
        mode="inline"
        items={items}
      />
      <div className="newministry-right-container">
        <div className="newministry-content">{renderContent()}</div>
      </div>
    </div>
  );
}

export default NewMinistry;
